import styled from '@emotion/styled';
import Typewriter from 'typewriter-effect';
import { typography } from '~/modules/Elements/cssMixins';
import styles from '~/modules/GameEngine/Drawing/styles';
import { PlayerScore } from '~/routes/Game/Singing/PostGame/PostGameView';
import ScoreBar from '~/routes/Game/Singing/PostGame/Views/Results/ScoreBar';
import useViewportSize from '~/modules/hooks/useViewportSize';

interface Props {
  playerNumber: 0 | 1 | 2 | 3;
  player: PlayerScore;
  segment: number;
}

function PlayerDetailedScore({ playerNumber, player, segment }: Props) {
  const [detailedScore, maxScore] = player.detailedScore;

  const { width } = useViewportSize();
  const isMobile = (width ?? 9999) < 640;

  return (
    <Wrapper data-mobile={isMobile}>
      <ScoreBarContainer data-mobile={isMobile}>
        <ScoreBar
          score={segment > -1 ? detailedScore.rap + detailedScore.freestyle + detailedScore.normal : 0}
          maxScore={maxScore.rap + maxScore.freestyle + maxScore.normal}
          color={styles.colors.players[playerNumber].perfect.fill}
        />

        <ScoreBar
          score={segment > 0 ? detailedScore.perfect : 0}
          maxScore={maxScore.perfect}
          color={styles.colors.players[playerNumber].stroke}
        />

        <ScoreBar
          score={segment > 1 ? detailedScore.star : 0}
          maxScore={maxScore.star}
          color={styles.colors.players[playerNumber].starPerfect.stroke}
        />

        <ScoreBar
          score={segment > 2 ? detailedScore.vibrato : 0}
          maxScore={maxScore.vibrato}
          color={styles.colors.players[playerNumber].perfect.stroke}
        />
      </ScoreBarContainer>

      <ScoreDescription data-mobile={isMobile}>
        {segment < 5 && (
          <Typewriter
            options={{
              strings: ['Regular notes', 'Perfect notes', 'Star notes', 'Vibrato'],
              // @ts-expect-error missing in types
              pauseFor: 1_000,
              autoStart: true,
              delay: 15,
              deleteSpeed: 15,
              cursor: '',
            }}
          />
        )}
      </ScoreDescription>
    </Wrapper>
  );
}

export default PlayerDetailedScore;

const Wrapper = styled.div`
  width: 100%;
  position: relative;
`;

/**
 * ✅ En móvil: más bajito y sin “reventar” verticalmente
 */
const ScoreBarContainer = styled.div`
  position: relative;
  height: 5rem;
  width: 100%;
  display: flex;
  flex-direction: row;
  border-radius: 1rem;
  gap: 0.5rem;
  box-sizing: border-box;
  background: rgba(0, 0, 0, 0.5);
  padding: 0.5rem;

  &[data-mobile='true'] {
    height: 3.8rem;
    padding: 0.45rem;
    border-radius: 14px;
    gap: 0.4rem;
  }
`;

/**
 * ✅ Antes estaba absolute con top fijo (se descuadra en móvil).
 * En móvil lo pasamos a “debajo” en flow normal.
 */
const ScoreDescription = styled.span`
  ${typography};
  font-size: 3rem;
  white-space: nowrap;
  display: block;

  position: absolute;
  top: 6rem;
  left: 1rem;

  &[data-mobile='true'] {
    position: relative;
    top: auto;
    left: auto;
    margin-top: 0.45rem;
    font-size: clamp(12px, 3.8vw, 16px);
    opacity: 0.95;
    white-space: normal;
  }
`;